import {
  AddressModel,
  JobFormAnswerModel,
  WorkAvailability,
} from "../../shared/models";

export const acceptedResumeTypes = [
  "application/pdf",
  "application/vnd.oasis.opendocument.text",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/png",
  "image/jpeg",
];

export type CandidateRequestModel = {
  name: string;
  archiveID: string | null;
  storagePosition: string | null;
  familyName: string;
  contact: string; //email
  telephoneNumber: string;
  // cvCoverName: string;
  // cvCoverInBase64: string;
  cvFileName: string;
  cvInBase64: string;
  formAnswers?: JobFormAnswerModel[];
  // Custom fields added below:
  address: AddressModel;
  fiscalCode: string;
  languages: string[];
  dateOfBirth: string;
  applicantPreferences: string;
  citizenWorkStatus: string;
  commercialLicense: boolean;
  desiredSalary: number;
  disabilityPercentage: number;
  drivingLicense: boolean;
  felonyConviction: boolean;
  gender: string;
  hardSkills: string[];
  jobQualification: string;
  links: string[];
  pilotFlightHours: number;
  protectedCategoryStatus: boolean;
  softSkills: string[];
  willingnessToTravel: boolean;
  workAvailability: WorkAvailability;
  certifications: string[];
  hobbyAndInterests: string[];
  nationality: string;
  convyData?: ConvyDataCandidateRequestModel;
};

interface ConvyDataCandidateRequestModel {
  newsletterConsent?: boolean;
  schoolTypeID?: string;
  studyPathID?: string;
  disciplineID?: string;
}

export type JobApplicationRequestModel = {
  creationDateTime: string;
  jobRef: string;
  jobTitle: string;
  utmSource: string;
  utmMedium?: string;
  utmCampaign?: string;
  candidate: CandidateRequestModel;
};

export interface Address {
  display_name: string;
  address: {
    house_number?: string;
    road?: string;
    street?: string;
    city?: string;
    town?: string;
    village?: string;
    postcode?: string;
    state?: string;
    country?: string;
    county?: string;
  };
}

type Dictionary = {
  it: string;
  en?: string;
};

export type ConvyHardSkill = {
  id: number;
  code?: string;
  titolo: Dictionary;
  descrizione: Dictionary;
  slug: string;
};

export type ConvyDiscipline = {
  id: number;
  percorso_studio_id: number;
  categoria_percorso: string;
  code?: string;
  titolo: Dictionary;
  descrizione: Dictionary;
  slug: string;
  settori_annunci?: string;
  funzioni_annunci?: string;
};

export type ConvyStudyPath = {
  id: number;
  code?: string;
  categoria: string;
  filename: string;
  filename_thumb: string;
  titolo: Dictionary;
  descrizione: Dictionary;
  ordinamento: number;
  slug: string;
  frontend_home_json?: string;
};

export type ConvySchoolType = {
  id: number;
  nome: Dictionary;
  categoria?: string;
};
